// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__zL9NG","tab":"ProcedureTabs_tab__olsBj"};